/* @ngInject */

export default (
  $rootScope,
  helperService,
  helperPdfService,
  incomeService,
  householdsService,
  assetsService,
  liabilitiesService
) => {
  /**
   * Prepare financial position details.
   *
   * @param {Array} contacts
   * @param {Object} ticket
   * @param {Object} loan
   * @param {Object} workflow
   *
   * @returns {Object}
   */
  const prepareFinancialPositionDetails = ({ contacts, ticket, loan, workflow }) => {
    const content = [];
    if (workflow?.isAssetFinance()) {
      content.push({
        text: '',
        margin: [0, 20, 0, 0]
      });
      content.push(
        helperPdfService.createHeader({
          title: 'FINANCIAL POSITION'
        })
      );

      const personContacts = _.filter(contacts, (c) => !c.isCompany);
      const totalAllIncome = () => {
        let total = 0;
        for (let i = 0; i < contacts?.length; i += 1) {
          total += incomeService.getTotalAllIncomeByContact({
            income: ticket?.income,
            idContact: contacts[i].id,
            contacts,
            assets: ticket?.assets,
            homeLoanSecurities: [],
            workflowType: workflow.type,
            isDealOwnerBroker: true,
            haveLendersExisting: true,
            isUsingForFinanceCalculations: true
          });
        }
        return total;
      };
      const totalIncome = totalAllIncome() / 12;
      const totalExpenses = householdsService.getTotalExpenses({
        expenses: ticket?.expenses || []
      });
      const totalAssets = assetsService.getTotalAssets(
        ticket?.assets || [],
        loan?.assetCommitmentSchedules || []
      );
      const totalLiabilities = liabilitiesService.getTotalLiabilitiesBalance(
        ticket?.liabilities || [],
        loan?.assetCommitmentSchedules || []
      );
      const totalExistingRepayments = helperService.getTotalExistingLiabilitiesRepayments({
        liabilities: ticket?.liabilities || [],
        assetCommitmentSchedules: loan?.assetCommitmentSchedules || [],
        workflow,
        isCurrent: true
      });
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            ['', '', '', ''],
            ['', '', '', '']
          ]
        },
        layout: 'noBorders'
      });
      content[content.length - 1].table.body[0][0] = {
        text: [
          { text: 'Total income\n', style: 'label' },
          {
            text: totalIncome.formatWithCurrency($rootScope.CurrentCurrency(), 0),
            style: 'value'
          }
        ]
      };
      if (personContacts.length) {
        content[content.length - 1].table.body[0][1] = {
          text: [
            { text: 'Total expenses\n', style: 'label' },
            {
              text: totalExpenses.formatWithCurrency($rootScope.CurrentCurrency(), 0),
              style: 'value'
            }
          ]
        };
      }
      content[content.length - 1].table.body[0][personContacts.length ? 2 : 1] = {
        text: [
          { text: 'Total assets\n', style: 'label' },
          {
            text: totalAssets.formatWithCurrency($rootScope.CurrentCurrency(), 0),
            style: 'value'
          }
        ]
      };
      content[content.length - 1].table.body[0][personContacts.length ? 3 : 2] = {
        text: [
          { text: 'Total liabilities\n', style: 'label' },
          {
            text: totalLiabilities.formatWithCurrency($rootScope.CurrentCurrency(), 0),
            style: 'value'
          }
        ]
      };
      content[content.length - 1].table.body[personContacts.length ? 1 : 0][
        personContacts.length ? 0 : 3
      ] = {
        text: [
          { text: 'Total existing repayments\n', style: 'label' },
          {
            text: totalExistingRepayments.formatWithCurrency($rootScope.CurrentCurrency(), 0),
            style: 'value'
          }
        ]
      };
      content[content.length - 1].table.body[1][personContacts.length ? 1 : 0] = {
        text: [
          { text: 'New repayments\n', style: 'label' },
          {
            text: loan?.financeProposal?.estimatedRepayment.formatWithCurrency(
              $rootScope.CurrentCurrency(),
              0
            ),
            style: 'value'
          }
        ]
      };
    }
    return content;
  };

  return {
    prepareFinancialPositionDetails
  };
};
